'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    transform: ', ';\n    height: ', ';\n    width: ', ';\n    ', ';\n\t  ', ';\n\t  ', ';\n\t  ', ';\n'], ['\n    transform: ', ';\n    height: ', ';\n    width: ', ';\n    ', ';\n\t  ', ';\n\t  ', ';\n\t  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../icons/helpers');

var _helpers2 = _interopRequireDefault(_helpers);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _inactive = require('../../icons/carousel/inactive');

var _inactive2 = _interopRequireDefault(_inactive);

var _hover = require('../../icons/carousel/hover');

var _hover2 = _interopRequireDefault(_hover);

var _disabled = require('../../icons/carousel/disabled');

var _disabled2 = _interopRequireDefault(_disabled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.div(_templateObject, function (_ref) {
    var direction = _ref.direction;
    return 'rotate(' + direction + 'deg)';
}, function (_ref2) {
    var size = _ref2.size;
    return size && size.height + 'px';
}, function (_ref3) {
    var size = _ref3.size;
    return size && size.width + 'px';
}, function (_ref4) {
    var top = _ref4.top;
    return top && 'margin-top: ' + top + 'px;';
}, function (_ref5) {
    var bottom = _ref5.bottom;
    return bottom && 'margin-bottom: ' + bottom + 'px;';
}, function (_ref6) {
    var left = _ref6.left;
    return left && 'margin-left: ' + left + 'px;';
}, function (_ref7) {
    var right = _ref7.right;
    return right && 'margin-right: ' + right + 'px;';
});

var CloseButton = function (_React$Component) {
    _inherits(CloseButton, _React$Component);

    function CloseButton(props) {
        _classCallCheck(this, CloseButton);

        var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));

        _this.state = {
            hover: false
        };
        return _this;
    }

    _createClass(CloseButton, [{
        key: 'getRotation',
        value: function getRotation(direction) {

            var rotation = 0;

            switch (direction) {
                case "left":
                    rotation = 0;
                    break;
                case "right":
                    rotation = 180;
                    break;
                case "up":
                    rotation = 90;
                    break;
                case "down":
                    rotation = 270;
                    break;
            }

            return rotation;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var size = this.props.size || 'medium';
            size = (0, _helpers2.default)(size);
            return _react2.default.createElement(
                Button,
                {
                    direction: this.getRotation(this.props.direction),
                    onMouseOver: function onMouseOver() {
                        return _this2.setState({ hover: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2.setState({ hover: false });
                    },
                    onClick: function onClick() {
                        return !_this2.props.disabled && _this2.props.clickEvent();
                    },
                    size: size,
                    top: (0, _getSize2.default)(this.props.top),
                    bottom: (0, _getSize2.default)(this.props.bottom),
                    left: (0, _getSize2.default)(this.props.left),
                    right: (0, _getSize2.default)(this.props.right) },
                this.props.disabled && _react2.default.createElement(_disabled2.default, { size: this.props.size }),
                !this.props.disabled && this.state.hover && _react2.default.createElement(_hover2.default, { size: this.props.size }),
                !this.props.disabled && !this.state.hover && _react2.default.createElement(_inactive2.default, { size: this.props.size })
            );
        }
    }]);

    return CloseButton;
}(_react2.default.Component);

exports.default = CloseButton;